



































































































































import Vue from 'vue';
import getCardSessionToken from './dependencies/get_card_token';
import WbTextFieldLoader from '@/components/skeleton_loaders/text_field.vue';
import Disclosure from '@/views/student/components/disclosure/index.vue';
import WbParagraphLoader from '@/components/skeleton_loaders/paragraph.vue';
import type { UpdatePaymentData } from '../../types';

export default Vue.extend({
  name: 'CreditCard',

  components: {
    WbTextFieldLoader,
    WbParagraphLoader,
    Disclosure,
  },

  props: {
    paymentState: {
      type: String,
    },
    projectName: {
      type: String,
    },
  },

  data() {
    return {
      error: '',
      invalid: true,
      hasAgreedToConditions: false,
      form: {
        nameOnCard: '',
        cardToken: '',
        lastFourDigits: '',
        exp: '',
        category: '',
        type: '',
      },
      errors: {
        nameOnCard: '',
        cardNumber: '',
        expiryDate: '',
        cvv: '',
      },
      formInputsState: 'loading',
    };
  },

  async mounted() {
    const { loanOrderId } = this.$route.params;

    try {
      this.formInputsState = 'loading';
      this.form.cardToken = await getCardSessionToken(loanOrderId);
      const obj = this.buildBluesnap(this.form.cardToken);
      window.bluesnap.hostedPaymentFieldsCreate(obj);

      // On bluesnap build success, state is set to loaded.
      // if more than 10s goes by, we assue it failed.
      setTimeout(() => {
        if (this.formInputsState === 'loading') {
          this.$emit('setErrorMessage', `
            We had trouble loading the credit card form. Try and refresh your browser.
            If this persists, please reach out to us.
          `);
        }
      }, 10000);
    } catch (error) {
      console.error('error building bluesnap ', error);
      this.$emit('setErrorMessage', `
        We had trouble loading the credit card form. Try and refresh your browser.
        If this persists, please reach out to us.
      `);
    }
  },

  methods: {

    onChangeName() {
      if (!this.form.nameOnCard) {
        this.errors.nameOnCard = 'Field Required';
      } else {
        this.errors.nameOnCard = '';
      }
    },

    disclosureChange(agreed: boolean) {
      this.hasAgreedToConditions = agreed;
    },

    downloadAgreementPlan() {
      this.$emit('download-agreement-plan');
    },

    async updatePayment() {
      this.error = '';

      if (!this.form.nameOnCard) {
        this.errors.nameOnCard = 'Field Required';
        return;
      }

      window.bluesnap.hostedPaymentFieldsSubmitData(
        async (callback) => {
          if (callback.error != null) {
            this.error = callback.error;
            return;
          }
          this.form = {
            nameOnCard: this.form.nameOnCard || '',
            cardToken: this.form.cardToken,
            lastFourDigits: callback.cardData.last4Digits || this.form.lastFourDigits,
            exp: callback.cardData.exp || this.form.exp,
            category: callback.cardData.binCategory || this.form.category,
            type: callback.cardData.cardSubType || this.form.type,
          };
          this.sendPaymentDetails();
        },
      );
    },

    async sendPaymentDetails() {
      const form: UpdatePaymentData = {
        paymentMethod: 'card',
        paymentInfo: {
          card: {
            token: this.form.cardToken,
            lastFourDigits: this.form.lastFourDigits,
            exp: this.form.exp,
            category: this.form.category,
            type: this.form.type,
          },
        },
      };

      this.$emit('update-payment', form);
    },

    buildBluesnap(sessiontoken: string) {
      return {
        // insert your Hosted Payment Fields token
        token: sessiontoken,
        onFieldEventHandler: {
          setupComplete: () => {
            this.formInputsState = 'loaded';
          },

          onError: (tagId: string, errorCode: string, errorDescription: string) => {
            switch (tagId) {
            case 'ccn':
              this.errors.cardNumber = errorDescription;
              break;
            case 'exp':
              this.errors.expiryDate = errorDescription;
              break;
            case 'cvv':
              this.errors.cvv = errorDescription;
              break;
            default:
              break;
            }
          },

          onValid: (tagId) => {
            switch (tagId) {
            case 'ccn':
              this.errors.cardNumber = '';
              break;
            case 'exp':
              this.errors.expiryDate = '';
              break;
            case 'cvv':
              this.errors.cvv = '';
              break;
            default:
              break;
            }
          },

          onFocus(tagId) {
          // Handle focus
          // changeImpactedElement(tagId, 'hosted-field-valid hosted-field-invalid', 'hosted-field-focus');
          },

          onBlur(tagId) {
            // Handle blur
            // changeImpactedElement(tagId, 'hosted-field-focus');
          },
        },
        // styling is optional
        style: {
          ':focus': {
            color: '#40496b',
          },
          input: {
            color: '#40496b',
            'font-size': '0.875rem',
          },
        },
        ccnPlaceHolder: '4111222233334444',
        cvvPlaceHolder: '123',
        expPlaceHolder: 'MM / YY',
      };
    },
  },
});
